import { Field, useFormikContext } from 'formik'
import CurrencyInput from 'react-currency-input-field'

export default function Currency({
  name,
  placeholder,
  defaultValue,
}: {
  name: string
  placeholder?: string
  defaultValue?: string
}) {
  return (
    <Field
      className="border border-gray-300 text-sm font-medium leading-none rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 text-gray-900 bg-white-100"
      name={name}
      placeholder={placeholder}
      component={CurrencyEl}
      defaultValue={defaultValue}
    />
  )
}

function CurrencyEl({ field, ...props }: { field: any }) {
  const { setFieldValue } = useFormikContext()
  return (
    <CurrencyInput
      allowNegativeValue={false}
      decimalScale={2}
      groupSeparator="."
      disableGroupSeparators
      decimalSeparator=","
      maxLength={18}
      onValueChange={(value, name) => {
        setFieldValue(name!, value)
      }}
      value={field.value}
      name={field.name}
      {...props}
    />
  )
}
